import React from "react";
import Reveal from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function WhyUs() {
  const { t } = useLang();

  return (
    <section className="relative py-24 lg:py-40 bg-[#0c0c0e] overflow-hidden" data-testid="why-us-section">
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none">
        <img
          src="/images/interior-texture.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container-x relative">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <div className="overline mb-4">{t.why.overline}</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1]">
              {t.why.title.split("\n").map((l, i) => (
                <span key={l || `why-title-${i}`} className="block">{l}</span>
              ))}
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10">
          {t.why.items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08}>
              <div className="bg-[#0c0c0e] p-8 lg:p-12 h-full">
                <div className="font-serif text-7xl text-[#C5A059]/25 leading-none mb-4">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-serif text-2xl lg:text-3xl mb-3">{item.title}</h3>
                <p className="text-white/60 text-base leading-relaxed max-w-md">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
